import util from '@bmp-vue/core/api/util'

const controller = 'AlteracaoBoleto'
export default Object.assign({}, util.GetCrud(controller, ['post']))
